import { useState } from 'react';
import './App.css';
import 'antd/dist/reset.css';
import 'react-json-view-lite/dist/index.css';
import { ConfigProvider, Layout } from 'antd';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Auth0Provider, useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import { useMediaQuery } from './utils/helpers/utils';
import { AppMenu } from './components/layout/AppMenu';
import { AppHeader } from './components/layout/AppHeader';
import { AppFooter } from './components/layout/AppFooter';
import { themeConfig } from './config/themeConfig';
import { useDisplayMode } from './hook/useDisplayMode';
import { AppContent } from './components/layout/AppContent';
import { Redirect, Route, Switch } from 'react-router-dom';

const SIDER_WIDTH = 250;
const SIDER_COLLAPSED_WIDTH = 80;

const App: React.FC = () => {
  const { user } = useAuth0();
  const isMobile = useMediaQuery();
  const [isCollapsed, setIsCollapsed] = useState(true);
  useDisplayMode();

  console.log(user);

  return (
    <ConfigProvider theme={themeConfig}>
      <Layout>
        <AppMenu isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
        <Layout className="site-layout" style={{ marginLeft: isMobile ? 0 : isCollapsed ? SIDER_COLLAPSED_WIDTH : SIDER_WIDTH }}>
          <AppHeader />
          <AppContent />
          <AppFooter />
        </Layout>
      </Layout>
      <ToastContainer />
    </ConfigProvider>
  );
};

const Root: React.FC = () => {
  return (
    <Auth0Provider
      domain="https://login.aryballe.com"
      clientId="CVch796WLukfGM4X1IpC3NIcUlUp9lTQ"
      authorizationParams={{
        redirect_uri: window.location.origin + '/signin/callback',
        scope: 'openid email profile assigned_groups',
        audience: 'https://tools.aryballe.com/api/',
      }}
    >
      <Switch>
        <Route path="/signout/callback">
          <Redirect to="/" />
        </Route>
        <Route path="/" component={withAuthenticationRequired(App)} />
      </Switch>
    </Auth0Provider>
  );
};
export default Root;
